import { useContext } from 'react';
import RegistryTemplate from '../../../Templates/RegistryTemplate';
import { WWContextValue, WWContext } from '../../../WWContext';
import SinglePageDesktopRegistrySection from './Desktop/SinglePageDesktopRegistrySection';
import { isWwsWeddingWebsiteV2 } from '../../../../types/graphql';

interface SinglePageRegistrySectionProps {
  isMobile: boolean;
}

const SinglePageRegistrySection = ({
  isMobile,
}: SinglePageRegistrySectionProps) => {
  const { data } = useContext<WWContextValue>(WWContext);

  if (!isWwsWeddingWebsiteV2(data?.weddingWebsiteResult)) {
    return null;
  }

  if (isMobile) {
    return <RegistryTemplate forceVisible />;
  } else {
    return (
      <SinglePageDesktopRegistrySection
        weddingWebsiteResult={data.weddingWebsiteResult}
      />
    );
  }
};

export default SinglePageRegistrySection;
